import * as React from 'react';
import XOutlined from './x-outlined';
import XFilled from './x-filled';
import type { IconCombinedProps } from './types';
const XCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <XFilled ref={ref} {...rest} />;
  }
  return <XOutlined ref={ref} {...rest} />;
});
export default XCombined;